import { render, staticRenderFns } from "./SaveChangeButton.vue?vue&type=template&id=be51db08&scoped=true&"
import script from "./SaveChangeButton.vue?vue&type=script&lang=js&"
export * from "./SaveChangeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be51db08",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be51db08')) {
      api.createRecord('be51db08', component.options)
    } else {
      api.reload('be51db08', component.options)
    }
    module.hot.accept("./SaveChangeButton.vue?vue&type=template&id=be51db08&scoped=true&", function () {
      api.rerender('be51db08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Button/SaveChangeButton.vue"
export default component.exports